import { createApp } from "vue";
import App from "./App.vue";
import store from "./store"; // vuex
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "./assets/css/common.css";
import "./assets/scss/pineapple-globals.scss";
import VueSweetalert2 from "vue-sweetalert2";
import MaterialDashboard from "./material-dashboard";
import i18n from "./lang/lang.js"; // Language 설정
import CONF from "./Config.js"; // 시스템 구성정보
import common from "@/plugins/common.js";
import axios from "axios";
import Notifications from '@kyvg/vue3-notification';
import MonacoEditor from '@guolao/vue-monaco-editor';
import bootstrap from "bootstrap/dist/js/bootstrap.min.js";

// https://www.npmjs.com/package/vue-loading-overlay
import { LoadingPlugin } from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import { Field, Form as VeeForm, ErrorMessage, defineRule } from "vee-validate";
import { required, email, min } from "@vee-validate/rules";

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

// 커스텀 디렉티브 - 권한 체크 제거됨

// vee-validate 규칙 정의
defineRule("required", required);
defineRule("email", email);
defineRule("min", min);

// 앱 인스턴스 생성
const app = createApp(App);

// 글로벌 프로퍼티 설정 (CONF와 같은 전역 설정)
app.config.globalProperties.$CONF = CONF;
// Axios를 글로벌 프로퍼티로 추가
app.config.globalProperties.$axios = axios;
// Bootstrap을 글로벌 프로퍼티로 추가
app.config.globalProperties.$bootstrap = bootstrap;

// vee-validate 컴포넌트 전역 등록
app.component("Field", Field);
app.component("MyForm", VeeForm);
app.component("ErrorMessage", ErrorMessage);
app.component("MonacoEditor", MonacoEditor);

// 플러그인 사용
app.use(store);
app.use(router);
app.use(i18n);
app.use(VueSweetalert2);
app.use(MaterialDashboard);
app.use(common); // Vue에서 this.메소드명 으로 사용
app.use(LoadingPlugin);
app.use(Notifications);

// 커스텀 디렉티브 등록 - 권한 체크 제거됨

app.directive('tooltip', {
    mounted(el, binding) {
        tippy(el, {
            content: binding.value,
            placement: 'top',
            animation: 'fade',
        });
    },
});

/* Vuex Store에 Router와 Axios를 주입
    아래의 방식으로 vuex에서 router, axios를 사용할 수 있다
    store.$router
    store.$axios
*/
store.$router = router;
store.$axios = app.config.globalProperties.$axios;

// 라우터 전역 가드 설정 (인증 체크만 - 권한 체크 제거됨)
router.beforeEach(async (to, from, next) => {
    // 1. 인증 예외 페이지 (로그인, 로그아웃)
    const exceptArr = ["/authentication/signin", "/logout"];
    const isExceptPage = exceptArr.includes(to.path);

    // 2. 인증 체크
    if (!isExceptPage) {
        const token = localStorage.getItem("access_token");

        // 토큰이 없으면 로그인 페이지로
        if (!token || token === "null") {
            return next({
                path: "/authentication/signin",
                query: { redirect: to.fullPath },
            });
        }

        // 로그인 상태가 아니면 사용자 정보 로드
        if (!store.state.auth.is_login) {
            try {
                await store.dispatch("auth/getMemberInfo");
            } catch (err) {
                console.error("Failed to fetch user info:", err);
                return next({
                    path: "/authentication/signin",
                    query: { redirect: to.fullPath },
                });
            }
        }

        // 권한 체크 제거됨 - 모든 로그인한 사용자는 모든 페이지에 접근 가능
    }

    // 3. 모든 체크 통과 시 이동 허용
    next();
});

// 앱 마운트
app.mount("#app");

// 운영 모드 설정
if (process.env.NODE_ENV === "production") {
    app.config.devtools = false;
    app.config.debug = false;
    app.config.silent = true;
}